import React, { useState, useEffect, useCallback } from "react";

import axios from "axios";

const UserCreate = ({ currentUser }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    pseudoName: "",
    empCode: "",
    password: "",
    isActive: "",
    role: "",
    center: "",
    tlName: "",
    dialerId: ""
  });

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [editUserId, setEditUserId] = useState(null); // ✅ Track editing user
  const [loading, setLoading] = useState(false);


 const fetchUsers = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/users");

      const hierarchy = [
        "SuperAdmin",
        "Admin",
        "Manager",
        "Team Leader",
        "Assessor",
        "QA Manager",
        "QA",
        "MIS Manager",
        "MIS",
        "Verifier",
        "Agent"
      ];

      const currentRole = currentUser?.role;
      const currentCenter = currentUser?.center;
      const currentLevel = hierarchy.indexOf(currentRole);

      let filteredUsers = [];

      if (["Assessor", "QA", "MIS"].includes(currentRole)) {
        filteredUsers = [];
      } else {
        filteredUsers = res.data.filter((user) => {
          const userLevel = hierarchy.indexOf(user.role);
         if (currentRole === "SuperAdmin") {
  // ⭐ SuperAdmin: ignore center, but keep hierarchy
  return userLevel > currentLevel;
}

// ⭐ Normal roles: center + hierarchy
return userLevel > currentLevel && user.center === currentCenter;

        });
      }

      setUsers(filteredUsers);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  }, [currentUser]); // ✅ dependencies for useCallback

  // ✅ now useEffect can safely depend on it
  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);




// const fetchUsers = async () => {
//   try {
//     setLoading(true); // ✅ start loading
//     const res = await axios.get("https://crm-server-htk6.vercel.app/api/users");
//     setUsers(res.data);
//   } catch (error) {
//     console.error("Error fetching users:", error);
//   } finally {
//     setLoading(false); // ✅ stop loading
//   }
// };






  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // ✅ Save new user
  const handleSave = async () => {
    if (!formData.firstName || !formData.lastName || !formData.empCode || !formData.password) {
      alert("Please fill required fields!");
      return;
    }

    try {
      await axios.post("https://crm-server-htk6.vercel.app/api/users", {
        ...formData,
        isActive: formData.isActive === "true"
      });
      alert("User saved successfully ✅");
      fetchUsers();
      resetForm();
    } catch (error) {
      alert("Error saving user ❌");
      console.error(error);
    }
  };

  // ✅ Start editing a user
  const handleEdit = (user) => {
    setFormData({
      firstName: user.firstName,
      lastName: user.lastName,
      pseudoName: user.pseudoName,
      empCode: user.empCode,
      password: user.password,
      isActive: user.isActive ? "true" : "false",
      role: user.role,
      center: user.center,
      tlName: user.tlName,
      dialerId: user.dialerId
    });
    setEditUserId(user._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Update user
  const handleUpdate = async () => {
    try {
      await axios.put(`https://crm-server-htk6.vercel.app/api/users/${editUserId}`, {
        ...formData,
        isActive: formData.isActive === "true"
      });
      alert("User updated successfully ✨");
      fetchUsers();
      resetForm();
    } catch (error) {
      alert("Error updating user ❌");
      console.error(error);
    }
  };

  const resetForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      pseudoName: "",
      empCode: "",
      password: "",
      isActive: "true",
      role: "",
      center: "",
      tlName: "",
      dialerId: ""
    });
    setEditUserId(null);
  };

  // // ✅ Delete single user
  // const handleDelete = async (id) => {
  //   if (!window.confirm("Are you sure you want to delete this user?")) return;
  //   try {
  //     await axios.delete(`https://crm-server-htk6.vercel.app/api/users/${id}`);
  //     alert("User deleted successfully ❌");
  //     fetchUsers();
  //     setSelectedUsers((prev) => prev.filter((uid) => uid !== id));
  //   } catch (error) {
  //     alert("Error deleting user ❌");
  //     console.error(error);
  //   }
  // };

  // ✅ Checkbox toggle
  const handleCheckboxChange = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((uid) => uid !== id) : [...prev, id]
    );
  };

  // ✅ Select All
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedUsers(users.map((u) => u._id));
    } else {
      setSelectedUsers([]);
    }
  };

  // // ✅ Bulk delete
  // const handleBulkDelete = async () => {
  //   if (selectedUsers.length === 0) {
  //     alert("No users selected for deletion ❌");
  //     return;
  //   }
  //   if (!window.confirm(`Delete ${selectedUsers.length} selected users?`)) return;
  //   try {
  //     await axios.delete("https://crm-server-htk6.vercel.app/api/users", {
  //       data: { ids: selectedUsers }
  //     });
  //     alert("Selected users deleted successfully ❌");
  //     setSelectedUsers([]);
  //     fetchUsers();
  //   } catch (error) {
  //     alert("Error deleting selected users ❌");
  //     console.error(error);
  //   }
  // };



  const [centers, setCenters] = useState([]);

  // ✅ Fetch centers 
  useEffect(() => {
    fetchCenters();
  }, []);

  const fetchCenters = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/centers");
      setCenters(res.data); // assume each center has _id and centerName
    } catch (err) {
      console.error("❌ Error fetching centers:", err);
    }
  };

  const [searchCenter, setSearchCenter] = useState("");
const [searchFirstName, setSearchFirstName] = useState("");
const [filteredTableData, setFilteredTableData] = useState([]);
const handleFilter = () => {
  let temp = [...users];

  if (searchCenter.trim() !== "") {
    temp = temp.filter((u) =>
      u.center?.toLowerCase() === searchCenter.trim().toLowerCase()
    );
  }

  if (searchFirstName.trim() !== "") {
    temp = temp.filter((u) =>
      u.firstName?.toLowerCase().includes(searchFirstName.trim().toLowerCase())
    );
  }

  setFilteredTableData(temp);
};
const handleClearFilter = () => {
  setSearchCenter("");
  setSearchFirstName("");
  setFilteredTableData(users);
};




  return (
    <div className="page" style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
    {loading && (
  <div className="loading-overlay">
    <div className="spinner"></div>
    ⏳ Fetching Users ...
  </div>
)}

      <h2 style={{ textAlign: "center", color: "#2a9d8f" }}>User Management</h2>

      {/* User Create / Update Form */}
      <div
        className="form-container"
        style={{
          background: "#f8f9fa",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#264653" }}>
          {editUserId ? "✏️ Update User" : " Create New User"}
        </h3>

        <div className="form-row" style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} style={{ flex: 1, padding: "8px" }} />
          <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} style={{ flex: 1, padding: "8px" }} />
          <input type="text" name="pseudoName" placeholder="Pseudo Name" value={formData.pseudoName} onChange={handleChange} style={{ flex: 1, padding: "8px" }} />
        </div>

        <div className="form-row" style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <input type="text" name="empCode" placeholder="Employee Code" value={formData.empCode} onChange={handleChange} style={{ flex: 1, padding: "8px" }} />
          <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} style={{ flex: 1, padding: "8px" }} />
          <input type="text" name="dialerId" placeholder="Dialer ID" value={formData.dialerId} onChange={handleChange} style={{ flex: 1, padding: "8px" }} />
        </div>

        <div className="form-row" style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
          <select name="isActive" value={formData.isActive} onChange={handleChange} style={{ flex: 1, padding: "8px" }}>
          <option value="">Select Status</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>

          <select name="role" value={formData.role} onChange={handleChange} style={{ flex: 1, padding: "8px" }}>
            <option value="">Select Role</option>
            <option value="SuperAdmin">Super Admin</option>
            <option value="Admin">Admin</option>
            <option value="Team Leader">Team Leader</option>   
              <option value="Manager">Manager</option>  
                <option value="Assessor">Assessor</option>  
                <option value="QA">QA</option>  
                <option value="QA Manager">QA Manager</option>  
                  <option value="MIS">MIS</option>     
                  <option value="MIS Manager">MIS Manager</option>                       
            <option value="Agent">Agent</option>
            <option value="Verifier">Verifier</option>
           
          </select>

          <select
      name="center"
      value={formData.center}
      onChange={handleChange}
      style={{ flex: 1, padding: "8px" }}
    >
      <option value="">Select Center</option>
      {centers.map((center) => (
        <option key={center._id} value={center.centerName}>
          {center.centerName}
        </option>
      ))}
    </select>

     <input type="text" name="tlName" placeholder="TL Name " value={formData.tlName} onChange={handleChange} style={{ flex: 1, padding: "8px" }} />

          
        </div>

        {/* Action buttons */}
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            className="save-btn"
            onClick={editUserId ? handleUpdate : handleSave}
            style={{
              background: editUserId ? "#e9c46a" : "#2a9d8f",
              color: "white",
              padding: "10px 16px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              flex: 1
            }}
          >
            {editUserId ? "✏️ Update User" : "💾 Save User"}
          </button>

          {editUserId && (
            <button
              onClick={resetForm}
              style={{
                background: "#e63946",
                color: "white",
                padding: "10px 16px",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
                flex: 1
              }}
            >
              ❌ Cancel
            </button>
          )}
        </div>
      </div>
{/* Search Filters */}
<div
  style={{
    display: "flex",
    gap: "10px",
    marginBottom: "15px",
    background: "#f4f4f4",
    padding: "15px",
    borderRadius: "8px",
    alignItems: "center"
  }}
>
  <input
    type="text"
    placeholder="Search by Center"
    value={searchCenter}
    onChange={(e) => setSearchCenter(e.target.value)}
    style={{ flex: 1, padding: "8px" }}
  />

  <input
    type="text"
    placeholder="Search by First Name"
    value={searchFirstName}
    onChange={(e) => setSearchFirstName(e.target.value)}
    style={{ flex: 1, padding: "8px" }}
  />

  <button
    onClick={handleFilter}
    style={{
      background: "#2a9d8f",
      color: "white",
      padding: "8px 16px",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer"
    }}
  >
    GO
  </button>

  <button
    onClick={handleClearFilter}
    style={{
      background: "#e63946",
      color: "white",
      padding: "8px 16px",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer"
    }}
  >
    Clear
  </button>
</div>

      {/* Users List */}
{/* Header + Bulk delete button in one row */}
{/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
  <h3 className="list-title" style={{ margin: 0 }}>📋 Created Users</h3>
  <button
    onClick={handleBulkDelete}
    style={{
      background: selectedUsers.length > 0 ? "#e63946" : "gray",
      color: "white",
      padding: "8px 16px",
      borderRadius: "6px",
      border: "none",
      cursor: selectedUsers.length > 0 ? "pointer" : "not-allowed",
      transition: "0.2s"
    }}
    disabled={selectedUsers.length === 0}
  >
    🗑 Delete Selected ({selectedUsers.length})
  </button>
</div> */}



      <div className="table-container" style={{ overflowX: "auto" }}>
        <table className="user-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f4f4f4" }}>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={users.length > 0 && selectedUsers.length === users.length}
                />
              </th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Pseudo Name</th>
              <th>Emp Code</th>
              <th>Password</th>
              <th>Active</th>
              <th>Role</th>
              <th>Center</th>
              <th>TL Name</th>
              <th>Dialer ID</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="12" style={{ textAlign: "center", padding: "12px" }}>
                  No users created yet
                </td>
              </tr>
            ) : (
             (filteredTableData.length > 0 ? filteredTableData : users).map((u) => (

                <tr key={u._id} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={selectedUsers.includes(u._id)}
                      onChange={() => handleCheckboxChange(u._id)}
                    />
                  </td>
                  <td>{u.firstName}</td>
                  <td>{u.lastName}</td>
                  <td>{u.pseudoName}</td>
                  <td>{u.empCode}</td>
                  <td>{u.password}</td>
                  <td>{u.isActive ? "Yes" : "No"}</td>
                  <td>{u.role}</td>
                  <td>{u.center}</td>
                  <td>{u.tlName}</td>
                  <td>{u.dialerId}</td>
                  <td style={{ textAlign: "center" }}>
  <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
    <button
      onClick={() => handleEdit(u)}
      style={{
        background: "#457b9d",
        color: "white",
        border: "none",
        padding: "5px 10px",
        borderRadius: "4px",
        cursor: "pointer"
      }}
    >
      ✏️ Edit
    </button>
    {/* <button
      style={{
        background: "#e63946",
        color: "white",
        border: "none",
        padding: "5px 10px",
        borderRadius: "4px",
        cursor: "pointer"
      }}
      onClick={() => handleDelete(u._id)}
    >
      🗑 Delete
    </button> */}
  </div>
</td>

                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserCreate;
